import React from 'react';
import {
  columnCreatedBy,
  columnCreatedByLink,
  columnCreatedOn,
  hasColumn,
} from '@/constants/fields';
import NameDescriptionColumns from '@/components/table/NameDescriptionColumns';
import UnsortedColumn from '@/components/table/UnsortedColumn';

const NotificationsTableColumns = ({ columns }) => (
  <NameDescriptionColumns entity="notifications" columns={columns}>
    {hasColumn(columns, [columnCreatedBy, columnCreatedByLink]) && (<UnsortedColumn columnId={columnCreatedBy} />)}
    {hasColumn(columns, columnCreatedOn) && (<UnsortedColumn columnId={columnCreatedOn} />)}
  </NameDescriptionColumns>
);

export default NotificationsTableColumns;
